module.exports = __webpack_public_path__ + "resources/img/bg_cover_service_m_v2.099c871c201ff70d875a8404143c3c85.png";